module.exports = __webpack_public_path__ + "assets/projects/digital-data-collection/project-header.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/digital-data-collection/project-header.jpg
// module id = 39
// module chunks = 0